import { useId } from 'react';
import { Table } from 'react-bootstrap';

import { evidenceRows } from './evidenceRows';

type EvidenceTableProps = {
  evidence: Record<string, unknown>;
  name: string;
};

export const EVIDENCE_TITLE = 'Evidence';
const NOTHING_RECORDED = 'No evidence recorded';

function EvidenceTable({ evidence, name }: EvidenceTableProps) {
  const titleId = useId();
  const rows = evidenceRows(evidence);

  return (
    <section className="diagnostics-detail-section" aria-labelledby={titleId}>
      <h2 id={titleId} className="diagnostics-detail-section-title">
        {EVIDENCE_TITLE}
      </h2>
      {rows.length === 0 && <p className="diagnostics-detail-empty">{NOTHING_RECORDED}</p>}
      {rows.length > 0 && (
      <Table className="diagnostics-evidence-table" aria-label={name}>
        <tbody>
          {rows.map((row) => (
            <tr key={row.name}>
              <th scope="row">{row.name}</th>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      )}
    </section>
  );
}

export default EvidenceTable;
